import { render, staticRenderFns } from "./SecondNewPromo.vue?vue&type=template&id=7712fa43&scoped=true"
import script from "./SecondNewPromo.vue?vue&type=script&lang=js"
export * from "./SecondNewPromo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SecondNewPromo.vue?vue&type=style&index=1&id=7712fa43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7712fa43",
  null
  
)

export default component.exports